var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaginationPrev = function SvgIconPaginationPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M10.75 17.793a1 1 0 0 1-1.414 1.414l-5.793-5.793a2 2 0 0 1 0-2.828l5.793-5.793a1 1 0 1 1 1.414 1.414L5.957 11h14.086a1 1 0 1 1 0 2H5.957z"
  })));
};
export default SvgIconPaginationPrev;